var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMutualWalletBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9mqootu4ic",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o4u53pttyf",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "0xq390msfa",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "hty87n86xd",
    d: "M8.708 0c2.068 0 3.29 1.187 3.29 3.203v.022h-2.54c-1.183.002-2.141.936-2.143 2.089-.002 1.155.957 2.093 2.142 2.095H12v.184c0 2.015-1.222 3.207-3.29 3.207H3.29C1.222 10.8 0 9.608 0 7.593v-4.39C0 1.187 1.222 0 3.29 0h5.418zm2.861 4.14c.212 0 .387.156.424.362L12 4.58V6.1c0 .216-.152.395-.353.433l-.078.007H9.62c-.57.01-1.071-.391-1.197-.962-.014-.076-.022-.154-.022-.232-.001-.623.46-1.136 1.053-1.2l.12-.006h1.996zm-1.969.6c-.331 0-.6.269-.6.6 0 .331.269.6.6.6.331 0 .6-.269.6-.6 0-.331-.269-.6-.6-.6zM6.23 2.325H2.844c-.252.001-.456.2-.457.446-.001.247.203.448.457.45h3.39c.253-.002.458-.203.457-.45 0-.247-.208-.447-.461-.446z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120 -356) translate(0 324) translate(92) translate(16 16) translate(12 12) translate(0 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hwh5d6hp9b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0xq390msfa"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#9mqootu4ic)",
    mask: "url(#hwh5d6hp9b)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120 -356) translate(0 324) translate(92) translate(16 16) translate(12 12) translate(0 4) translate(6 6.857)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o5e34kxgce",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hty87n86xd"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#o5e34kxgce)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#o4u53pttyf)",
    d: "M0 0H12.857V12H0z",
    transform: "translate(-.204 -.262)"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutualWalletBalance);
export default __webpack_public_path__ + "static/media/mutual-wallet-balance.e6b8f91f62c33880a173299dc0ed53c8.svg";
export { ForwardRef as ReactComponent };